import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17e5f6aa")

_pushScopeId("data-v-17e5f6aa")
const _hoisted_1 = { class: "fridgedetails-radiobuttonitem" }
const _hoisted_2 = { class: "fridgedetails-radiobuttonitem-title" }
const _hoisted_3 = { class: "fridgedetails-radiobuttonitem-title-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "fridgedetails-radiobuttonitem-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectItem(...args)))
    }, [
      _createVNode("img", {
        class: "fridgedetails-radiobuttonitem-button-image",
        src: _ctx.buttonImage
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.text), 1)
    ])
  ]))
})